// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as AttachmentADefault } from '../../../assets/icons/default/editor/attachment-a.svg?react';
import { ReactComponent as AttachmentASolid } from '../../../assets/icons/solid/editor/ATTACHMENT-A.svg?react';
import { createIcons } from '../../Icon';
const AttachmentAIcon = /* @__PURE__ */ createIcons('AttachmentA', {
    default: AttachmentADefault,
    solid: AttachmentASolid
});
AttachmentAIcon.supportedTypes = ['default', 'solid'];
AttachmentAIcon.category = 'editor';
export default AttachmentAIcon;
